module.exports = __webpack_public_path__ + "static/media/tvrepair.341a61e7.jpeg";